const setSitesToErrorMessageModalCloneCheck = {
  errSite: 'tiene una checklist.'
};

export default setSitesToErrorMessageModalCloneCheck;
